<template>
    <v-container style="padding-top: 70px;">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-card flat class="text-xs-center ma-3" width="100%">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white;">Agregar Movimiento</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-row justify="center">
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Número Reporte:</label>
                                <v-text-field v-model="reporte"
                                              maxlength="8"
                                              outlined
                                              dense
                                              @keypress="filter($event)">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <label class="typo__label" style="text-align: center;">Número Índice:</label>
                                <v-text-field v-model="indice"
                                              maxlength="6"
                                              outlined
                                              dense
                                              @keypress="filter($event)">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="8">
                                <label class="typo__label" style="text-align: center;">Abogado:</label>
                                <multiselect v-model="busqueda.abogado" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="prclave" label="prnombre" placeholder="Seleccionar un Abogado"
                                             :options="abogados" :allow-empty="false">
                                </multiselect>
                                <span style="color: red;" v-show="validaabo">Selección requerida</span>
                            </v-col>
                            <v-col cols="12" md="8">
                                <label class="typo__label" style="text-align: center;">Estado:</label>
                                <multiselect v-model="busqueda.estatus" deselect-label="No se puede remover el valor seleccionado"
                                             selected-label="Seleccionado" select-label="Seleccionar valor"
                                             track-by="ctclaveespod" label="ctestatus" placeholder="Seleccionar un Estado"
                                             :options="estatuss" :allow-empty="false">
                                </multiselect>
                                <span style="color: red;" v-show="validaestatus">Selección requerida</span>
                            </v-col>
                            <v-col cols="12" md="8">
                                <label class="typo__label" style="text-align: center;">Observaciones:</label>
                                <v-textarea :counter="300"
                                            outlined
                                            v-model="observacion"
                                            v-on:blur="observacion = observacion.trim()"
                                            name="input-7-4"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2"
                                       @click="Guardar()"
                                       color="primary">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" @click="Limpiar()" color="default">
                                    Limpiar
                                </v-btn>
                                <v-btn class="ma-2" @click="Cancelar()" color="error">
                                    Cancelar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-expansion-panels v-model="vermovimiento" multiple>
                    <v-expansion-panel class="active-class">
                        <v-expansion-panel-header class="card-title-text"
                                                  style="min-height: 20px !important"
                                                  color="primary">Movimientos</v-expansion-panel-header>
                        <v-expansion-panel-content v-if="ver">
                            <br />
                            <DataTable :url="urlmovimiento"
                                       :columns="headmovimiento"
                                       :params="displaymovimiento"
                                       :order="[]"
                                       @apiDT="apiDT = $event">
                            </DataTable>
                            <v-row>
                                <v-col cols="12" class="text-center">
                                    <v-btn class="ma-2"
                                           @click="Detalles()"
                                           color="success">
                                        Detalles
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                    
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import Menu from '@/components/pages/operacion/MenuEstadisticas/Menu.vue';
    import General from "@/services/Operacion/Operacion.service.js";
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                ver: false,
                validForm: true,
                vermovimiento: [0],
                showcargando: true,
                reporte: '',
                indice: '',
                observacion: '',
                busqueda: {
                    estatus: '',
                    abogado: ''
                },
                estatuss: [],
                abogados: [],
                rules: {
                    required: value => !!value || 'Campo requerido',
                },
                rulestextarea: [
                    v => !!v || 'Campo requerido',
                    v => {
                        if (v == null) {
                            return true
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }

                            else
                                return true
                        }
                    },
                ],
                validaabo: false,
                validaestatus: false,
                displaymovimiento: {},
                urlmovimiento: 'Operacion/ObtenerMovimientos',
                headmovimiento: [
                    { name: "prnombre", data: "prnombre", title: "Nombre", },
                    { name: "nrreporte", data: "nrreporte", title: "N° de Reporte" },
                    { name: "svindice", data: "svindice", title: "N° de Índice", },
                    { name: "podfhalta", data: "podfhalta", title: "Fecha Alta" },
                    { name: "hpocomentario", data: "hpocomentario", title: "Comentarios", },
                ],
                podclave: '',
            }
        },
        methods: {
            async Guardar() {
                if (this.busqueda.estatus == '') {
                    this.validaestatus = true;
                }

                if (this.busqueda.abogado == '')
                    this.validaabo = true;

                if (this.$refs.form.validate() && this.validaabo == false && this.validaestatus == false) {
                    let Ban = 0;
                    let form = new FormData();
                    form.append("podclave", this.podclave);
                    form.append("nrreporte", this.reporte);
                    form.append("svindice", this.indice);

                    let dat = new FormData();
                    dat.append("podclave", this.podclave);
                    dat.append("prclave", this.busqueda.abogado != '' ? this.busqueda.abogado.prclave : null);
                    dat.append("hpocomentario", this.observacion);
                    dat.append("ctclaveespod", this.busqueda.estatus != '' ? this.busqueda.estatus.ctclaveespod : null);
                    dat.append("nrreporte", this.reporte);
                    dat.append("svindice", this.indice);
                    
                    if (this.reporte != '' && this.indice) {
                        await General.ValidarReporteIndice(this, form).then(data => {
                            Ban = data;
                            if (data == 2) {
                                this.$swal(
                                    "Atención",
                                    "El reporte o índice no corresponde al Cliente dado de Alta en el poder. Verifíquelos de nuevo",
                                    "info"
                                );
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    title: "Procesando Guardando ...",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    confirm: false,
                                });
                                this.$swal.showLoading();
                                General.AltaMovimiento(this, dat).then(datos => {
                                    if (datos[0].success == 'true') {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito!",
                                            html: datos[0].mensaje,
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                this.Limpiar();
                                                this.reloadTable();
                                            }
                                        });
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "warning",
                                            title: "Error!",
                                            html: datos[0].mensaje,
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                //this.Limpiar();
                                                //this.reloadTable();
                                            }
                                        });
                                    }

                                });
                            }
                        });
                        
                    }
                    else {
                        this.$swal({
                            position: "center",
                            title: "Procesando Guardando ...",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirm: false,
                        });
                        this.$swal.showLoading();
                        await General.AltaMovimiento(this, dat).then(data => {
                            if (data[0].success == 'true') {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Éxito!",
                                    html: data[0].mensaje,
                                    confirmButtonText: "Aceptar",
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.Limpiar();
                                        this.reloadTable();
                                    }
                                });
                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "warning",
                                    title: "Error!",
                                    html: data[0].mensaje,
                                    confirmButtonText: "Aceptar",
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        //this.Limpiar();
                                        //this.reloadTable();
                                    }
                                });
                            }

                        });
                    }
                }
            },
            Detalles() {
                this.$router.go(-1);
            },
            Cancelar() {
                this.$router.go(-1);
            },
            reloadTable() {

                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            Limpiar() {
                this.busqueda.estatus = '';
                this.busqueda.abogado = '';
                this.$refs.form.reset();
            },
            async ListadoEstatus() {
                await General.ListadoEstatus(this).then(data => {
                    this.estatuss = data;
                });
            },
            async ListadoProveedor() {
                await General.ListadoProveedor(this).then(data => {
                    this.abogados = data;
                });
            },
            filter: function (evt) {
                evt = (evt) ? evt : window.event;
                let expect = evt.target.value.toString() + evt.key.toString();

                if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        },
        watch: {
            'busqueda.abogado'(val) {
                if (this.busqueda.abogado != '')
                    this.validaabo = false;
            },
            'busqueda.estatus'(val) {
                if (this.busqueda.estatus != '')
                    this.validaestatus = false;
            },
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        async mounted() {
            if (window.sessionStorage.getItem("poderes") != null) {
                let poderes = await MetodosGenerales.obtenerSessionReporte('poderes');
                this.podclave = poderes.podclave;
                this.ListadoProveedor();
                this.ListadoEstatus();
                this.displaymovimiento = {
                    podclave: poderes.podclave
                }
                this.ver = true;
            }
            this.showcargando = false;
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '275').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>
<style scoped>
    .title-card-style {
        padding: 1.5px !important;
        max-height: auto;
    }

    .card-title-text {
        font-family: "Poppins", sans-serif;
        font-weight: 600;
        font-size: 1em;
        color: white;
    }

    .Texto {
        font-weight: bold;
    }
</style>